module.exports = __webpack_public_path__ + "static/img/setting.a2c4b60a.svg";